import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.info = {
      ...state.app.emisores.info,
      ...data,
    };
  });
};

const info = async (store, id, params = {}) => {
  store.setState((state) => {
    state.app.emisores.info.busy = true;
  });

  try {
    const response = await Http.get(`api/emisores/${id}`, { params });

    store.setState((state) => {
      state.app.emisores.info.busy = false;
      state.app.emisores.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.info.busy = false;
      state.app.emisores.info.error = error.data || error;
    });
  }
};

const infoFromProfile = async (store, params = {}) => {
  store.setState((state) => {
    state.app.emisores.info.busy = true;
  });

  try {
    const headers = {
      'X-Tenancy': 'fa/live',
    };

    const response = await Http.get('/auth/me', { params, headers });

    store.setState((state) => {
      state.app.emisores.info.busy = false;
      state.app.emisores.info.data = {
        ...state.app.emisores.info.data,
        ...response.data.emisor,
        series: response.data.emisor.series || [],
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.info.busy = false;
      state.app.emisores.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.info = { ...initialState };
  });
};

const EmisorInfoStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    info,
    infoFromProfile,
    reset,
  },
};

export default EmisorInfoStore;
